import { CartRequest } from "../models/cart-item";
import { PresentableOption, Vehicle } from "../models/common-data-types";

export function mapToCartRequest(option: PresentableOption,selectedVehicle: Vehicle, 
    selectedInsuranceType: string): CartRequest{
    
    return{
        vehicleId: selectedVehicle.id,
        coverQuote: {
            annualPremium: option.annualPremium,
            premiumDue: option.premiumDue,
            packageId: option.packageId,
            providerName: option.providerName,
            packageName: option.packageName,
            paymentFrequency: option.paymentFrequency
        },
        insuranceType: selectedInsuranceType,
        vehicleValue: selectedVehicle.vehicleValue
    }
}